import { RESET_FIELD, SET_FIELD } from "../actions/field.actions";

const initialState = {
  data: null,
};

const field = (state = initialState, action) => {
  switch (action.type) {
    case SET_FIELD:
      return {
        ...state,
        data: action.payload,
      };
    case RESET_FIELD:
      return {
        ...state,
        data: null,
      };
    default:
      return state;
  }
};

export default field;
